"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* Package Imports */
var react_1 = __importStar(require("react"));
/* Blast Imports */
var ContainerPanel_1 = require("@app/components/layout/ContainerPanel");
var SplitPage_1 = require("@app/components/layout/SplitPage");
/**
 * Blast's Registration Confirmation page component
 */
var RegistrationConfirmationPage = /** @class */ (function (_super) {
    __extends(RegistrationConfirmationPage, _super);
    function RegistrationConfirmationPage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RegistrationConfirmationPage.prototype.render = function () {
        var rcpState = this.props.location.state; // Registration Confirmation Page location state
        return (react_1.default.createElement(SplitPage_1.SplitPage, { title: "Registration Confirmation" },
            react_1.default.createElement(ContainerPanel_1.ContainerPanel, { title: "Thank You" },
                react_1.default.createElement("p", null,
                    "The account (",
                    rcpState.email,
                    ") has been created.",
                    react_1.default.createElement("br", null),
                    "An email has been sent to ",
                    rcpState.email,
                    " requesting you to reset your password.",
                    react_1.default.createElement("br", null),
                    "Follow the instructions in the email to log into your account."))));
    };
    return RegistrationConfirmationPage;
}(react_1.Component));
exports.default = RegistrationConfirmationPage;
